export default __webpack_public_path__ + "static/fr-fa603df2e3f2c881ea52c937f3081aee.svg";